// dashboardApi.js
import { apiCall } from './apiCall';



export default function dashboardApi() {
  return {
    getDashboardData: (data,token) => apiCall('/getDashboardBalanceStockReport',data, token),
    getDashboardGraph: (data,token) => apiCall('/getDashboardGraph',data, token),
  };
}
